import { render, staticRenderFns } from "./Trans.vue?vue&type=template&id=6fb41cc4&scoped=true&"
import script from "./Trans.vue?vue&type=script&lang=js&"
export * from "./Trans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb41cc4",
  null
  
)

export default component.exports